module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap"
  }, [_c('div', {
    staticClass: "for-blur-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "header flex-box"
  }, [_c('div', {
    staticClass: "header-left flex-1 back",
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jiantou-copy"
  })]), _vm._v(" "), (!_vm.notIndex) ? _c('div', {
    staticClass: "header-logo"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "header-middle"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('v-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("学院")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-right flex-1"
  }, [_c('span', {
    staticClass: "iconfont menu",
    attrs: {
      "id": "menuLockerBtn"
    }
  }, [_vm._v("")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e826e1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 16
// module chunks = 8 9 10 11 12